import { KustomerApi } from '../../generated/api';
import configuration from './configuration';

export default new KustomerApi(configuration);
